import React from "react";
import UserDetailsView from "../../../../views/dashboard/users/Details";

const UserDetails = () => {
  return <UserDetailsView />;
};

export default UserDetails;
